import React from 'react';

function Terms() {
  return (
    <div className="terms-container">
      <h1>Termeni și condiții</h1>
      <div className="terms-content">
        <section>
          <h2>Termeni și condiții de utilizare</h2>
          <p>
            Prin accesarea și utilizarea platformei Aleph (alephmedia.ro), utilizatorul acceptă în mod expres și necondiționat următoarele termeni și condiții.
          </p>
        </section>

        <section>
          <h2>Termeni generali</h2>
          <p>
            Prin utilizarea acestui site, www.alephnews.ro, sunteți de acord cu termenii și condițiile de utilizare menționate în această pagină. 
            Accesul și utilizarea acestui site sunt supuse următorilor termeni și condiții de utilizare și tuturor legilor și regulamentelor aplicabile.
          </p>
        </section>

        <section>
          <h2>Conținutul</h2>
          <p>
            Conținutul site-ului este destinat uzului personal, fără scop direct ori indirect comercial. 
            Toate materialele publicate (incluzând, dar fără a se limita la, articole, informații, date, 
            cotații, grafice, fotografii, clipuri video, sunet, software) sunt protejate de drepturile de 
            autor și de alte legi privind proprietatea intelectuală.
          </p>
        </section>

        <section>
          <h2>Răspundere juridică</h2>
          <p>
            Conținutul acestui site, inclusiv știrile, cotațiile, datele și alte informații, este furnizat 
            de ALEPHNEWS.RO și de către furnizorii săi de conținut. Acest site furnizează instrumente de 
            informare, însă nu oferă niciun fel de sfat și nici nu face vreo recomandare referitoare la 
            anumite instrumente financiare, investiții sau produse.
          </p>
        </section>

        <section>
          <h2>Actualizare</h2>
          <p>
            Aceste Condiții de Confidențialitate sunt actualizate de câte ori este nevoie. Modificările se 
            vor reflecta în tipul de informații publicate sau transmise de către ALEPHNEWS.RO. Vă rugăm să 
            citiți periodic aceste condiții, pentru a fi la curent cu ce informații colectează, folosește 
            și transmite ALEPHNEWS.RO.
          </p>
        </section>
      </div>
    </div>
  );
}

export default Terms; 